











































import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    filters: {
      type: Object,
      required: true,
    },
    filterValues: {
      type: Object,
      required: true,
    },
  },
  emits: ['onClearFilters', 'onChangeFilter'],
  setup(_, { emit }) {
    // Clear filters with emit
    const clearFilters = () => {
      emit('onClearFilters')
    }

    // Change filter values with emit
    const onChange = (event: Event, filterKey: string) => {
      const target = event.target as HTMLInputElement
      emit('onChangeFilter', {
        filterKey,
        value: target.value,
      })
    }

    return {
      clearFilters,
      onChange,
    }
  },
})
